import { css } from 'lit';

export const adminUpdatesViewStyles = css`
  view-content {
    /* nothing yet */
  }
`;
